"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Login;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_native_paper_1 = require("react-native-paper");
const react_native_biometrics_1 = __importStar(require("react-native-biometrics"));
const react_i18next_1 = require("react-i18next");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const Theme_1 = require("../Theme");
const Helper_1 = require("../Helper");
const Authentication_1 = __importDefault(require("../shared/Authentication"));
const Button_1 = __importDefault(require("../components/Button"));
const PasswordInput_1 = __importDefault(require("../components/PasswordInput"));
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const Biometrics_1 = __importDefault(require("../api/Biometrics"));
const GoogleSignIn_1 = require("../shared/GoogleSignIn");
const AuthForms_1 = require("../partials/AuthForms");
const Register_1 = __importDefault(require("../api/Register"));
const Loading_1 = __importDefault(require("../components/Loading"));
const react_native_mask_text_1 = require("react-native-mask-text");
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const EnterpriseRecaptcha_1 = __importStar(require("../components/EnterpriseRecaptcha"));
const react_native_device_info_1 = __importDefault(require("react-native-device-info"));
const Google_svg_1 = __importDefault(require("../images/Google.svg"));
const base64_js_1 = __importDefault(require("base64-js"));
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const SessionContext_1 = require("../contexts/SessionContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const AppleSignIn_1 = require("../shared/AppleSignIn");
const Meta_1 = __importDefault(require("../api/Meta"));
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        container: {
            backgroundColor: THEME.PrimaryDark,
            flex: 1,
            padding: 0,
            margin: 0
        },
        card: {
            backgroundColor: THEME.SoftGray,
            width: size != 'sm' ? 460 : '100%',
            borderColor: `${THEME.SoftGray}99`,
            borderRadius: 4,
            borderWidth: 1,
            elevation: 2,
            shadowColor: Helper_1.Helper.isPlatformWeb ? `${THEME.Black}22` : THEME.TextMuted,
            shadowOffset: { height: 2, width: 0 },
            shadowRadius: 2
        },
        section: {
            margin: 8,
        },
        sectionSideBySide: {
            margin: 8,
            flexDirection: 'row'
        },
        input: {
            backgroundColor: THEME.Surface,
            borderColor: THEME.CardBorder,
            borderWidth: 1,
            borderRadius: 2,
            color: THEME.Text,
            fontSize: 16,
            paddingHorizontal: 13,
            paddingVertical: 13
        },
        inputFocus: {
            borderColor: THEME.Primary
        },
        messageOuter: {
            marginTop: size != 'sm' ? 8 : 6
        },
        message: {
            color: THEME.Red,
            fontSize: 14,
            fontWeight: "500",
            textAlign: "center",
        },
        belowLink: {
            color: THEME.Primary,
            fontSize: size != 'sm' ? 16 : 14
        }
    });
};
const LoginForm = (props) => {
    const refUsername = react_1.default.useRef(null);
    const refPassword = react_1.default.useRef(null);
    const [focusedUsername, setFocusedUsername] = react_1.default.useState(false);
    const [focusedPassword, setFocusedPassword] = react_1.default.useState(false);
    const [username, setUsername] = react_1.default.useState("");
    const [password, setPassword] = react_1.default.useState("");
    const [verifyResolver, setVerifyResolver] = react_1.default.useState(null);
    const [working, setWorking] = react_1.default.useState(false);
    const workingRef = react_1.default.useRef(working);
    workingRef.current = working;
    const [message, setMessage] = react_1.default.useState(null);
    const [biometryTypeAvail, setBiometryTypeAvail] = react_1.default.useState(undefined);
    const [biometricsEnabled, setBiometricsEnabled] = react_1.default.useState(null);
    const [biometricError, setBiometricError] = react_1.default.useState(false);
    const biometricErrorRef = react_1.default.useRef(biometricError);
    biometricErrorRef.current = biometricError;
    const [googleSignInFeature, setGoogleSignInFeature] = react_1.default.useState(null);
    const [appleSignInFeature, setAppleSignInFeature] = react_1.default.useState(null);
    react_1.default.useEffect(() => {
        Meta_1.default.getGlobalUnauthenticatedFeatures().then((data) => {
            var appleData = data?.filter(x => x.id === "AppleSignIn");
            var googleData = data?.filter(x => x.id === "GoogleSignIn");
            if (appleData.length > 0)
                setAppleSignInFeature(appleData[0]);
            if (googleData.length > 0)
                setGoogleSignInFeature(googleData[0]);
        }).catch(e => {
            console.error(e);
        });
    }, []);
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const canUseGoogle = react_1.default.useCallback(() => {
        var globallyEnabled = googleSignInFeature !== null && googleSignInFeature !== undefined && googleSignInFeature.isEnabled;
        var deviceEnabled = false;
        if (react_native_1.Platform.OS === 'android' && !Helper_1.Helper.isPlatformWeb && globallyEnabled)
            deviceEnabled = googleSignInFeature.isAndroidEnabled ?? false;
        else if (react_native_1.Platform.OS === 'ios' && !Helper_1.Helper.isPlatformWeb && globallyEnabled)
            deviceEnabled = googleSignInFeature.isAppleEnabled ?? false;
        else if (Helper_1.Helper.isPlatformWeb && globallyEnabled)
            deviceEnabled = googleSignInFeature.isWebEnabled ?? false;
        if (react_native_1.Platform.OS == 'android' && react_native_1.Platform.Version < 33)
            deviceEnabled = false;
        return deviceEnabled;
    }, [googleSignInFeature]);
    const canUseApple = react_1.default.useCallback(() => {
        var globallyEnabled = appleSignInFeature !== null && appleSignInFeature !== undefined && appleSignInFeature.isEnabled;
        var deviceEnabled = false;
        if (react_native_1.Platform.OS === 'android' && !Helper_1.Helper.isPlatformWeb && globallyEnabled)
            deviceEnabled = appleSignInFeature.isAndroidEnabled ?? false;
        else if (react_native_1.Platform.OS === 'ios' && !Helper_1.Helper.isPlatformWeb && globallyEnabled)
            deviceEnabled = appleSignInFeature.isAppleEnabled ?? false;
        else if (Helper_1.Helper.isPlatformWeb && globallyEnabled)
            deviceEnabled = appleSignInFeature.isWebEnabled ?? false;
        return deviceEnabled;
    }, [appleSignInFeature]);
    // Allows passcode to be used as biometric fallback
    const rnBiometrics = new react_native_biometrics_1.default({ allowDeviceCredentials: true });
    const initBiometrics = async () => {
        if (workingRef.current || biometricErrorRef.current)
            return;
        let bioSetting = await async_storage_1.default.getItem("biometricsEnabled");
        setBiometricsEnabled(bioSetting);
        if (bioSetting === "Yes") {
            let { available, biometryType } = await rnBiometrics.isSensorAvailable();
            if (available && biometryType) {
                setBiometryTypeAvail(biometryType);
                if (Authentication_1.default.ConsumeSuppressBiometricAutoPromptOnce())
                    return;
                setTimeout(() => {
                    handleBiometricLogin();
                }, 250);
            }
        }
    };
    const loadStoredUsername = async () => {
        let user = await async_storage_1.default.getItem("username");
        setUsername(user?.toLowerCase() ?? '');
    };
    const handleUsername = (value) => {
        setUsername(value);
        async_storage_1.default.setItem("username", value?.toLowerCase() ?? '');
    };
    const handlePassword = (value) => {
        setPassword(value);
    };
    const trustedDeviceTrust = async (user) => {
        let accessToken;
        if (!Helper_1.Helper.isPlatformWeb)
            accessToken = await user.getIdToken();
        try {
            let r = await Register_1.default.trustedDeviceTrust(Helper_1.Helper.isPlatformWeb ? user.accessToken : accessToken);
            if (r.token && r.token.length > 96) {
                await async_storage_1.default.setItem('trustedDevice_' + (Helper_1.Helper.isPlatformWeb ? user.uid : username?.toLowerCase()), r.token);
            }
        }
        catch { }
    };
    const trustedDeviceVerify = async (error) => {
        let uid;
        try {
            if (!Helper_1.Helper.isPlatformWeb) {
                uid = username?.toLowerCase();
            }
            else {
                uid = error?.customData?._serverResponse?.localId;
            }
        }
        catch { }
        if (!uid)
            return false;
        try {
            let keys = await async_storage_1.default.getAllKeys();
            for (var k of keys) {
                // Remove any expired trusted device tokens.
                if (k.startsWith('trustedDevice_')) {
                    let value = await async_storage_1.default.getItem(k);
                    try {
                        let base64url = value.split('.')[0];
                        let base64 = Helper_1.Helper.base64FromUrl(base64url);
                        let jsonBytes = base64_js_1.default.toByteArray(base64);
                        let jsonString = String.fromCharCode.apply(null, jsonBytes);
                        let payload = JSON.parse(jsonString);
                        if (payload.exp < Math.round(Date.now() / 1000)) {
                            await async_storage_1.default.removeItem(k);
                        }
                    }
                    catch {
                        await async_storage_1.default.removeItem(k);
                    }
                }
            }
        }
        catch { }
        try {
            let deviceToken = await async_storage_1.default.getItem('trustedDevice_' + uid);
            if (deviceToken) {
                // Verify credentials and trusted device token.
                let r = await Register_1.default.trustedDeviceVerify(deviceToken, { username: username?.toLowerCase(), password });
                await Authentication_1.default.SignInWithToken(r.token, 'trusted_device');
                if (props.onSuccess)
                    props.onSuccess();
                return true;
            }
        }
        catch (e) {
            if (e?.status == 403) {
                await async_storage_1.default.removeItem('trustedDevice_' + uid);
            }
        }
        return false;
    };
    const handleLoginError = async (error) => {
        switch (error?.code) {
            case 'auth/multi-factor-auth-required':
                let trustedSuccess = await trustedDeviceVerify(error);
                if (!trustedSuccess) {
                    let resolver = Authentication_1.default.MfaVerifyStart(error);
                    setVerifyResolver(resolver);
                }
                break;
            case 'auth/too-many-requests':
                setMessage(t('login:messages.accountLocked'));
                break;
            case 'auth/popup-closed-by-user':
                break;
            case 'auth/admin-restricted-operation':
                setMessage(t('login:messages.adminRestricted'));
                break;
            case 'auth/unknown':
                if (react_native_1.Platform.OS === 'ios') {
                    setMessage(t('login:messages.adminRestricted'));
                    break;
                }
            // Fall through.
            default:
                setMessage(t('login:messages.loginFail'));
                break;
        }
    };
    react_1.default.useEffect(() => {
        let handleGoogle = Promise.resolve(null);
        if (Helper_1.Helper.isPlatformWeb) {
            // Google login redirect result on web.
            handleGoogle = GoogleSignIn_1.GoogleSignIn.GetRedirectResult();
        }
        handleGoogle.then((user) => {
            if (!user) {
                loadStoredUsername();
                // Initialize for non Google login.
                if (Helper_1.Helper.isPlatformWeb) {
                    refUsername.current?.focus();
                }
                else {
                    initBiometrics();
                }
            }
        }).catch(handleLoginError);
    }, []);
    react_1.default.useEffect(() => {
        if (Helper_1.Helper.isPlatformWeb)
            return;
        const deepLinkSub = react_native_1.DeviceEventEmitter.addListener('deepLink.received', () => {
            initBiometrics();
        });
        const appStateSub = react_native_1.AppState.addEventListener('change', (nextState) => {
            if (nextState === 'active') {
                initBiometrics();
            }
        });
        return () => {
            deepLinkSub.remove();
            appStateSub.remove();
        };
    }, []);
    const handleLogin = () => {
        if (username?.length > 0 &&
            password?.length > 0) {
            setWorking(true);
            Authentication_1.default.SignIn(username?.toLowerCase(), password)
                .then(() => props.onSuccess?.call())
                .catch(handleLoginError)
                .finally(() => setWorking(false));
        }
    };
    const handleGoogle = () => {
        setWorking(true);
        let loginGoogle = GoogleSignIn_1.GoogleSignIn.SignIn();
        if (!Helper_1.Helper.isPlatformWeb) {
            // Google login will redirect on web.
            // Handle it immediately on mobile.
            loginGoogle.catch(handleLoginError)
                .finally(() => setWorking(false));
        }
    };
    const handleApple = () => {
        setWorking(true);
        let loginApple = AppleSignIn_1.AppleSignIn.SignIn();
        loginApple.catch(handleLoginError)
            .finally(() => setWorking(false));
    };
    const handleBiometricLogin = async () => {
        if (workingRef.current)
            return;
        setWorking(true);
        // Just in case stored username or prismId are lost
        let [[, storedUsername], [, storedPrismId]] = await async_storage_1.default.multiGet(["username", "prismId"]);
        // Ensure the user has biometric keys on device
        let { keysExist } = await rnBiometrics.biometricKeysExist();
        if (!keysExist || !storedUsername || !storedPrismId) {
            react_native_1.Alert.alert(t('login:messages.oops'), t('login:messages.bioLogin'));
            setWorking(false);
            return;
        }
        const timestamp = Math.round(new Date().getTime() / 1000).toString();
        const payload = `${storedUsername?.toLowerCase()}_${timestamp}`;
        rnBiometrics.createSignature({ promptMessage: t('login:text.signIn'), payload: payload }).then((bioResult) => {
            if (!bioResult?.success || !bioResult?.signature) {
                setWorking(false);
                return;
            }
            Biometrics_1.default.verifyBiometrics({
                prismEmployeeId: storedPrismId,
                username: storedUsername?.toLowerCase(),
                signature: bioResult.signature,
                message: payload,
                biometryType: biometryTypeAvail
            }).then((r) => {
                return Authentication_1.default.SignInWithToken(r.customToken, 'biometric');
            })
                .then(() => {
                if (props.onSuccess) {
                    props.onSuccess();
                }
            })
                .catch(handleLoginError)
                .finally(() => {
                setWorking(false);
            });
        }).catch((error) => {
            const errStr = error?.toString()?.toLowerCase() ?? '';
            if (errStr.includes('cancel') || errStr.includes('user cancellation')) {
                setWorking(false);
                return;
            }
            if (error.toString().includes('Key permanently invalidated') ||
                error.toString().includes('Key user not authenticated')) {
                react_native_1.Alert.alert(t('login:messages.bioChanged'), t('login:messages.bioLogin'));
                async_storage_1.default.multiSet([['biometricsEnabled', 'No'], ['shouldClearBiometrics', 'true']]).then(() => {
                    rnBiometrics.deleteKeys().then(() => {
                        ;
                        setBiometricsEnabled("No");
                    });
                });
            }
            else {
                react_native_1.Alert.alert(t('login:messages.bioError'), t('login:messages.bioLogin'));
                setBiometricError(true);
            }
            setWorking(false);
        });
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { children: (verifyResolver == null)
            &&
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                backgroundColor: THEME.SoftGray,
                                borderBottomColor: THEME.ImageNull,
                                borderBottomWidth: (react_native_1.Platform.OS == 'android' && react_native_1.Platform.Version < 33) ? 1 : 0,
                                paddingHorizontal: size != 'sm' ? "4%" : "2%",
                                paddingVertical: "2%",
                            }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsx)(react_native_1.TextInput, { ref: refUsername, placeholderTextColor: THEME.OnSurfaceVariant, placeholder: t('login:labels.username'), "aria-label": t('login:labels.username'), onFocus: () => setFocusedUsername(true), onBlur: () => setFocusedUsername(false), onChangeText: handleUsername, onSubmitEditing: () => refPassword.current?.focus(), defaultValue: username, style: [styles.input, focusedUsername ? styles.inputFocus : {}] }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsx)(PasswordInput_1.default, { kind: "native", inputRef: refPassword, placeholderTextColor: THEME.OnSurfaceVariant, placeholder: t("login:labels.password"), ariaLabel: t("login:labels.password"), value: password, onChangeText: handlePassword, onSubmitEditing: handleLogin, onFocus: () => setFocusedPassword(true), onBlur: () => setFocusedPassword(false), style: [styles.input, focusedPassword ? styles.inputFocus : {}], showCapsWarning: Helper_1.Helper.isPlatformWeb }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.section, { flex: 1 }], children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('login:buttons.login'), accessibilityHint: t('login:hints.login'), disabled: working, onPress: handleLogin, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                        margin: 2,
                                                        color: working ? THEME.TextDisabled : THEME.White,
                                                        fontSize: 16,
                                                        fontWeight: '500'
                                                    }, children: t('login:buttons.login') }) }) }), !Helper_1.Helper.isPlatformWeb && biometricsEnabled === "Yes" && biometryTypeAvail && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.section, { flex: 1 }], children: (0, jsx_runtime_1.jsxs)(Button_1.default, { "aria-label": t('login:hints.bioLogin'), accessibilityHint: t('login:hints.bioLoginInfo'), type: "outline", disabled: working || biometricError, onPress: handleBiometricLogin, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: (working || biometricError) ? THEME.TextDisabled : THEME.PrimaryDark, icon: biometryTypeAvail === react_native_biometrics_1.BiometryTypes.FaceID ? Theme_1.ICONS.Regular.FaceViewfinder : Theme_1.ICONS.Regular.Fingerprint, size: 16, style: { marginRight: 6 } }), biometryTypeAvail === react_native_biometrics_1.BiometryTypes.Biometrics && (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: (working || biometricError) ? THEME.TextDisabled : THEME.PrimaryDark, margin: 2, fontSize: 16 }, children: t('login:buttons.biometrics') }), biometryTypeAvail === react_native_biometrics_1.BiometryTypes.FaceID && (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: (working || biometricError) ? THEME.TextDisabled : THEME.PrimaryDark, margin: 2, fontSize: 16 }, children: t('login:buttons.biometrics') }), biometryTypeAvail === react_native_biometrics_1.BiometryTypes.TouchID && (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: (working || biometricError) ? THEME.TextDisabled : THEME.PrimaryDark, margin: 2, fontSize: 16 }, children: t('login:buttons.biometrics') })] }) }))] }), !!message &&
                                    (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.message, children: message }) })] }), (canUseGoogle() || canUseApple()) &&
                            (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { justifyContent: 'center', flex: 1, flexDirection: 'row', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, height: 1, backgroundColor: THEME.ImageNull, marginRight: '2%' } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.TextLight }, children: t('login:labels.loginWith') }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, height: 1, backgroundColor: THEME.ImageNull, marginLeft: '2%' } })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                                borderTopColor: THEME.SoftGray,
                                borderTopWidth: 1,
                                paddingHorizontal: (size != 'sm' ? '4%' : '2%'),
                                paddingVertical: '2%',
                                backgroundColor: THEME.SoftGray,
                                borderBottomEndRadius: 2
                            }, children: [(canUseGoogle() || canUseApple()) &&
                                    (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [canUseGoogle() &&
                                                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.section, { flex: 1 }], children: (0, jsx_runtime_1.jsxs)(Button_1.default, { "aria-label": t('login:buttons.google'), accessibilityHint: t('login:hints.google'), type: "solid", color: THEME.NeutralGray + '58', disabled: working, onPress: handleGoogle, style: { height: 38 }, children: [(0, jsx_runtime_1.jsx)(Google_svg_1.default, { style: { paddingVertical: 2 }, height: 28, width: 28 }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                                    marginTop: 0,
                                                                    color: THEME.Text,
                                                                    fontSize: 16
                                                                }, children: t('login:buttons.google') })] }) }), canUseApple() &&
                                                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.section, { flex: 1 }], children: (0, jsx_runtime_1.jsxs)(Button_1.default, { style: { height: 38 }, "aria-label": t('login:buttons.apple'), accessibilityHint: t('login:hints.apple'), type: "solid", color: THEME.NeutralGray + '58', disabled: working, onPress: handleApple, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Apple, color: THEME.Text + '99', style: { paddingVertical: 2, marginTop: -2 }, size: 24 }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: {
                                                                    marginLeft: 2,
                                                                    marginTop: 0,
                                                                    color: THEME.Text,
                                                                    fontSize: 16
                                                                }, children: t('login:buttons.apple') })] }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap', marginTop: (react_native_1.Platform.OS == 'android' && react_native_1.Platform.Version < 33) ? 0 : 16 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Pressable, { hitSlop: 8, style: ({ pressed }) => [{ padding: 2, margin: 2, marginHorizontal: 8, maxWidth: '40%' }, pressed ? { opacity: 0.6 } : null], onPress: () => props.onForgotPassword(), children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.belowLink, { flexShrink: 1, flexWrap: 'wrap', textAlign: 'center' }], children: t('login:buttons.forgot') }) }), (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { hitSlop: 8, style: ({ pressed }) => [
                                                { padding: 2, marginVertical: 2, marginHorizontal: 8, maxWidth: '40%' },
                                                pressed ? { opacity: 0.6 } : null
                                            ], onPress: () => props.onForgotUsername(), children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: [styles.belowLink, { flexShrink: 1, flexWrap: 'wrap', textAlign: 'center' }], children: t('login:buttons.forgotUsername') }) })] })] })] })
            ||
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                        marginHorizontal: 8,
                        marginBottom: 8,
                        paddingHorizontal: (size != 'sm' ? '4%' : '2%'),
                        paddingBottom: '2%'
                    }, children: (0, jsx_runtime_1.jsx)(AuthForms_1.AuthMfaVerify, { resolver: verifyResolver, allowTrustDevice: password?.length > 0, onTrustDevice: (user) => trustedDeviceTrust(user), onSuccess: () => props.onSuccess?.call(), onCancel: () => setVerifyResolver(null) }) }) }));
};
const ForgotForm = (props) => {
    const [username, setUsername] = react_1.default.useState("");
    const [working, setWorking] = react_1.default.useState(false);
    const [requested, setRequested] = react_1.default.useState(false);
    const [message, setMessage] = react_1.default.useState(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const styles = useStyles();
    const handleRequest = async () => {
        if (username?.length > 0) {
            setWorking(true);
            Authentication_1.default.SendPasswordReset(username?.toLowerCase() ?? '')
                .then(() => {
                setRequested(true);
                setMessage("Request sent.");
            })
                .catch((error) => {
                switch (error?.code) {
                    case "auth/invalid-email":
                    case "auth/user-not-found":
                        setMessage(t('login:messages.badEmail'));
                        break;
                    default:
                        setMessage(t('login:messages.defaultErr'));
                        break;
                }
            })
                .finally(() => {
                setWorking(false);
            });
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
            paddingHorizontal: (size != 'sm' ? '4%' : '2%'),
            paddingVertical: '2%'
        }, children: requested
            &&
                ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.section, { marginTop: -2 }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, textAlign: 'center' }, children: t('login:text.requestSent') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('login:buttons.goBack'), accessibilityHint: t('login:hints.goBack'), color: THEME.Secondary, disabled: working, type: "outline", text: t('login:buttons.goBack'), onPress: () => props.navigation.navigate("Login") }) })] })) || ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.section, { marginTop: -2 }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, textAlign: 'center' }, children: t('login:text.sendRequest') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { label: t('login:labels.userEmail'), accessibilityHint: t('login:labels.userEmail'), value: username ?? '', style: {
                            height: (Helper_1.Helper.isPlatformWeb ? 50 : null)
                        }, autoFocus: true, mode: "outlined", onChangeText: (v) => setUsername(v) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: working, type: "outline", text: t('login:buttons.cancel'), onPress: () => props.navigation.navigate("Login") }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2, marginLeft: 12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('login:buttons.reset'), accessibilityHint: t('login:hints.reset'), disabled: working, text: t('login:buttons.reset'), onPress: handleRequest }) })] }) }), message && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.messageOuter, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.message, children: message }) }))] })) }));
};
const ForgotUsernameForm = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const paperTheme = (0, Theme_1.useGlobalPaperTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [lastFour, setLastFour] = react_1.default.useState("");
    const [firstName, setFirstName] = react_1.default.useState("");
    const [lastName, setLastName] = react_1.default.useState("");
    const [birthDate, setBirthDate] = react_1.default.useState("");
    const [zipCode, setZipCode] = react_1.default.useState("");
    const [working, setWorking] = react_1.default.useState(false);
    const [requested, setRequested] = react_1.default.useState(false);
    const [hideAnswer, setHideAnswer] = react_1.default.useState(true);
    const [nonce, setNonce] = react_1.default.useState("");
    const [username, setUsername] = react_1.default.useState("");
    const [question, setQuestion] = react_1.default.useState("");
    const [answer, setAnswer] = react_1.default.useState("");
    const [lastFourError, setLastFourError] = react_1.default.useState(false);
    const [firstNameError, setFirstNameError] = react_1.default.useState(false);
    const [lastNameError, setLastNameError] = react_1.default.useState(false);
    const [birthDateError, setBirthDateError] = react_1.default.useState(false);
    const [zipCodeError, setZipCodeError] = react_1.default.useState(false);
    const challengeQuestions = [
        { value: '1', label: t('register:questions.cityChallenge') },
        { value: '2', label: t('register:questions.maidenNameChallenge') },
        { value: '3', label: t('register:questions.petNameChallenge') },
        { value: '4', label: t('register:questions.elementarySchoolChallenge') },
        { value: '5', label: t('register:questions.highSchoolMascotChallenge') },
        { value: '6', label: t('register:questions.oldestSiblingChallenge') },
        { value: '7', label: t('register:questions.streetChallenge') },
        { value: '8', label: t('register:questions.concertChallenge') },
        { value: '9', label: t('register:questions.firstCarChallenge') },
        { value: '10', label: t('register:questions.fatherChallenge') }
    ];
    const handleAnswer = async () => {
        setWorking(true);
        Register_1.default.answerQuestion({
            nonce: nonce,
            answer: answer,
            questionId: question
        }).then(data => {
            FirebaseAnalytics_1.default.LogEvent('forgot_username', {
                status: 'success',
                platform: react_native_1.Platform.OS
            });
            setUsername(data.email?.toLowerCase());
            setNonce(data.token);
            setRequested(true);
        })
            .catch(error => {
            FirebaseAnalytics_1.default.LogEvent('forgot_username', {
                status: 'failed',
                platform: react_native_1.Platform.OS
            });
            react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t("login:messages.noUser") });
            props.navigation.navigate("Login");
        })
            .finally(() => {
            setWorking(false);
        });
    };
    const handleRequest = async () => {
        let tokenRef = new EnterpriseRecaptcha_1.EnterpriseRecaptchaToken();
        await tokenRef.getToken("USERNAME_REQUEST", (recaptchaToken) => {
            setWorking(true);
            setLastFourError(lastFour?.length != 4);
            setFirstNameError(!(firstName?.length > 0));
            setLastNameError(!(lastName?.length > 0));
            setBirthDateError(birthDate?.length != 10);
            setZipCodeError(zipCode?.length != 5);
            if (lastFour?.length == 4 && firstName?.length > 0 && lastName?.length > 0 && birthDate?.length == 10 && zipCode?.length == 5) {
                let [bdateMonth, bdateDay, bdateYear] = birthDate.split('/');
                Register_1.default.verifyDetails({
                    firstName,
                    lastName,
                    birthDate: bdateYear + '-' + bdateMonth + '-' + bdateDay,
                    zipCode,
                    ssn: lastFour,
                    token: recaptchaToken,
                    action: 'USERNAME_REQUEST'
                }).then(data => {
                    FirebaseAnalytics_1.default.LogEvent('forgot_username', {
                        status: 'success',
                        platform: react_native_1.Platform.OS
                    });
                    if (data.questionId) {
                        let verifyData = data;
                        setQuestion(verifyData.questionId);
                        setNonce(verifyData.nonce);
                    }
                    else {
                        let challengeData = data;
                        setUsername(challengeData.email?.toLowerCase());
                        setNonce(challengeData.token);
                    }
                    setRequested(true);
                })
                    .catch(error => {
                    FirebaseAnalytics_1.default.LogEvent('forgot_username', {
                        status: 'failed',
                        platform: react_native_1.Platform.OS
                    });
                    var message = t("login:messages.noUser");
                    if (error.status == 429) {
                        message = t('login:messages.waitTime');
                    }
                    react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: message });
                    props.navigation.navigate("Login");
                })
                    .finally(() => {
                    setWorking(false);
                });
            }
        });
    };
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
            paddingHorizontal: (size != 'sm' ? '4%' : '2%'),
            paddingVertical: '2%'
        }, children: [working && ((0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: false, loading: working })), (!working && (question != '' || username != '')) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(question != '' && username == '') && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.section, { marginTop: -2 }], children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, textAlign: 'center' }, children: t('login:text.challengeQuestion') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontWeight: '500', textAlign: 'center', marginTop: 12 }, children: challengeQuestions.filter(q => q.value === question)[0]?.label })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { label: t('login:labels.answer'), accessibilityHint: t('login:labels.answer'), value: answer ?? '', style: {
                                        height: (Helper_1.Helper.isPlatformWeb ? 50 : null)
                                    }, secureTextEntry: hideAnswer, right: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput.Icon, { style: { marginBottom: Helper_1.Helper.isPlatformWeb ? (props.height !== undefined ? 0 : 8) : 4 }, icon: ({ color, size }) => ((0, jsx_runtime_1.jsx)(Button_1.default, { hitSlop: 12, type: "borderless", onPress: () => setHideAnswer(!hideAnswer), dismissKeyboardOnPress: false, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: hideAnswer ? Theme_1.ICONS.Regular.Eye : Theme_1.ICONS.Regular.EyeSlash, color: THEME.Primary }) })), theme: {
                                            ...paperTheme,
                                            colors: {
                                                onSurfaceDisabled: THEME.Primary
                                            }
                                        } }), autoFocus: true, mode: "outlined", onChangeText: (v) => setAnswer(v) }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.sectionSideBySide, children: [(0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('login:buttons.goBack'), accessibilityHint: t('login:hints.goBack'), disabled: working, type: "outline", text: t('login:buttons.goBack'), style: { flex: nonce ? 1 : 2, marginRight: 4 }, onPress: () => props.navigation.navigate("Login") }), (nonce) && ((0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('login:buttons.requestUsername'), accessibilityHint: t('login:hints.requestUsername'), disabled: working, text: t('login:buttons.requestUsername'), style: { flex: 1, marginLeft: 4 }, onPress: () => handleAnswer() }))] })] })), (requested && username != '') && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.section, { marginTop: -2 }], children: [(0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: { color: THEME.Text, textAlign: 'center' }, children: [t('login:text.usernameIndicator'), ":"] }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontWeight: '500', textAlign: 'center' }, children: username })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.sectionSideBySide, children: [(0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('login:buttons.goBack'), accessibilityHint: t('login:hints.goBack'), disabled: working, type: "outline", text: t('login:buttons.goBack'), style: { flex: nonce ? 1 : 2, marginRight: 4 }, onPress: () => props.navigation.navigate("Login") }), (nonce) && ((0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('login:buttons.changeUsername'), accessibilityHint: t('login:hints.changeUsername'), disabled: working, text: t('login:buttons.changeUsername'), style: { flex: 1, marginLeft: 4 }, onPress: () => props.navigation.navigate("Login", { "mode": "resetUsername", "nonce": nonce }) }))] })] }))] })), (!working && question == '' && username == '') && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.section, { marginTop: -2 }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, textAlign: 'center' }, children: t('login:text.sendUsernameRequest') }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.sectionSideBySide, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { label: t('login:labels.firstName'), "aria-label": t('login:labels.firstName'), accessibilityHint: t('login:labels.firstName'), value: firstName ?? '', style: {
                                    height: (Helper_1.Helper.isPlatformWeb ? 50 : null),
                                    flex: 1,
                                    marginRight: 4
                                }, autoFocus: true, mode: "outlined", onChangeText: (v) => setFirstName(v), error: firstNameError }), (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { label: t('login:labels.lastName'), "aria-label": t('login:labels.lastName'), accessibilityHint: t('login:labels.lastName'), value: lastName ?? '', style: {
                                    height: (Helper_1.Helper.isPlatformWeb ? 50 : null),
                                    flex: 1,
                                    marginLeft: 4
                                }, mode: "outlined", onChangeText: (v) => setLastName(v), error: lastNameError })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { accessible: true, label: t('login:labels.birthDate') + ' (MM/DD/YYYY)', "aria-label": t('login:labels.birthDate'), accessibilityHint: t('login:labels.birthDate'), value: birthDate ?? '', style: {
                                height: (Helper_1.Helper.isPlatformWeb ? 50 : null),
                                flex: 1,
                                marginRight: 4
                            }, mode: "outlined", error: birthDateError, render: (props) => ((0, jsx_runtime_1.jsx)(react_native_mask_text_1.MaskedTextInput, { ...(() => { var { value, ...p } = props; return p; })(), type: "date", options: {
                                    dateFormat: 'MM/DD/YYYY'
                                }, mask: "99/99/9999", defaultValue: birthDate, onChangeText: (formatted, extracted) => {
                                    setBirthDate(formatted);
                                }, inputMode: 'numeric' })) }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.sectionSideBySide, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { label: t('login:labels.zipCode'), "aria-label": t('login:labels.zipCode'), accessibilityHint: t('login:labels.zipCode'), value: zipCode ?? '', style: {
                                    height: (Helper_1.Helper.isPlatformWeb ? 50 : null),
                                    flex: 1,
                                    marginRight: 4
                                }, mode: "outlined", error: zipCodeError, render: (props) => ((0, jsx_runtime_1.jsx)(react_native_mask_text_1.MaskedTextInput, { ...(() => { var { value, ...p } = props; return p; })(), defaultValue: zipCode, mask: '99999', onChangeText: (formatted, extracted) => {
                                        setZipCode(extracted);
                                    } })) }), (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { label: t('login:labels.lastFour'), accessible: true, "aria-label": t('login:hints.lastFour'), accessibilityHint: t('login:hints.lastFour'), value: lastFour ?? '', style: {
                                    height: (Helper_1.Helper.isPlatformWeb ? 50 : null),
                                    flex: 1,
                                    marginLeft: 4
                                }, mode: "outlined", error: lastFourError, render: (props) => ((0, jsx_runtime_1.jsx)(react_native_mask_text_1.MaskedTextInput, { ...(() => { var { value, ...p } = props; return p; })(), defaultValue: lastFour, mask: '9999', onChangeText: (formatted, extracted) => {
                                        setLastFour(extracted);
                                    } })) })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('login:buttons.cancel'), disabled: working, type: "outline", text: t('login:buttons.cancel'), onPress: () => props.navigation.navigate("Login") }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2, marginLeft: 12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('login:buttons.requestUsername'), accessibilityHint: t('login:hints.requestUsername'), disabled: working, text: t('login:buttons.requestUsername'), onPress: handleRequest }) })] }) }), (0, jsx_runtime_1.jsx)(EnterpriseRecaptcha_1.default, { action: "USERNAME_REQUEST" })] }))] }));
};
const ResetUsernameForm = (props) => {
    const [username, setUsername] = react_1.default.useState("");
    const [working, setWorking] = react_1.default.useState(false);
    const [usernameError, setUsernameError] = react_1.default.useState(false);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const handleRequest = async () => {
        var emailValid = username && username?.length > 0 && username.toLowerCase().match(/^(\w|(\w+\+\w))+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/i);
        if (emailValid) {
            setWorking(true);
            Register_1.default.changeUsername({
                nonce: props.nonce,
                email: username?.toLowerCase()
            }).then(data => {
                FirebaseAnalytics_1.default.LogEvent('change_username', {
                    status: 'success',
                    platform: react_native_1.Platform.OS
                });
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "success", message: t("login:messages.usernameChangeSuccess") + " " + username });
            })
                .catch(error => {
                FirebaseAnalytics_1.default.LogEvent('change_username', {
                    status: 'failed',
                    platform: react_native_1.Platform.OS
                });
                react_native_1.DeviceEventEmitter.emit("event.showSnackbar", { type: "error", message: t("login:messages.usernameChangeError") });
            })
                .finally(() => {
                setWorking(false);
                props.navigation.navigate("Login");
            });
        }
        else {
            setUsernameError(true);
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
            paddingHorizontal: (size != 'sm' ? '4%' : '2%'),
            paddingVertical: '2%'
        }, children: working && ((0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: false, loading: working }))
            ||
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.section, { marginTop: -2 }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, textAlign: 'center' }, children: t('login:text.changeUsername') }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.section, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { label: t('login:labels.username'), accessibilityHint: t('login:labels.username'), value: username ?? '', style: {
                                        height: (Helper_1.Helper.isPlatformWeb ? 50 : null)
                                    }, error: usernameError, autoFocus: true, mode: "outlined", onChangeText: (v) => setUsername(v), maxLength: 50 }), usernameError && (0, jsx_runtime_1.jsx)(react_native_paper_1.HelperText, { type: "error", children: usernameError ? t('common:messages.emailHelp') : '' })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: working, type: "outline", text: t('login:buttons.cancel'), onPress: () => props.navigation.navigate("Login") }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2, marginLeft: 12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('login:buttons.changeUsername'), accessibilityHint: t('login:hints.changeUsername'), disabled: working, text: t('login:buttons.changeUsername'), onPress: handleRequest }) })] }) })] }) }));
};
const ResetForm = (props) => {
    const [password, setPassword] = react_1.default.useState("");
    const [confirm, setConfirm] = react_1.default.useState("");
    const [working, setWorking] = react_1.default.useState(false);
    const [message, setMessage] = react_1.default.useState(null);
    const [isValid, setIsValid] = react_1.default.useState(false);
    const [complexityError, setComplexityError] = react_1.default.useState(false);
    const [matchError, setMatchError] = react_1.default.useState(false);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const verifyStrength = (pass, verify, useGlobal) => {
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
        var fallthrough = true;
        if (!passwordPattern.test(useGlobal ? password : pass)) {
            setIsValid(false);
            setMessage(t('login:messages.weakPass'));
            setComplexityError(true);
            fallthrough = false;
        }
        if (pass != verify) {
            setIsValid(false);
            setMatchError(true);
            // Prioritize weak password message
            if (fallthrough) {
                setComplexityError(false);
                setMessage(t('login:messages.passMismatch'));
            }
            fallthrough = false;
        }
        else {
            // Clear the match error if the passwords match
            setMatchError(false);
        }
        if (!fallthrough) {
            return;
        }
        setIsValid(true);
        setMessage(null);
        setComplexityError(false);
        setMatchError(false);
    };
    const handleReset = async () => {
        if (password != confirm) {
            setMessage(t('login:messages.passMismatch'));
        }
        else if (password?.length > 0) {
            setWorking(true);
            Authentication_1.default.ConfirmPasswordReset(props.code, password)
                .then(() => {
                props.navigation.navigate("Login");
            })
                .catch((error) => {
                switch (error?.code) {
                    case "auth/expired-action-code":
                        setMessage(t('login:messages.expiredLink'));
                        break;
                    case "auth/invalid-action-code":
                        setMessage(t('login:messages.invalidLink'));
                        break;
                    case "auth/weak-password":
                        setMessage(t('login:messages.weakPass'));
                        break;
                    default:
                        setMessage(t('login:messages.defaultErr'));
                        break;
                }
            })
                .finally(() => {
                setWorking(false);
            });
        }
    };
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
            paddingHorizontal: (size != 'sm' ? '4%' : '2%'),
            paddingVertical: '2%'
        }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.section, { marginTop: -2 }], children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, textAlign: 'center' }, children: t('login:text.enterNewPass') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { error: complexityError, label: t('login:labels.newPass'), accessibilityHint: t('login:labels.newPass'), value: password ?? "", dense: true, secureTextEntry: true, mode: "outlined", onChangeText: (v) => {
                        verifyStrength(v, confirm, false);
                        setPassword(v);
                    } }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { error: matchError, label: t('login:labels.confirmPass'), accessibilityHint: t('login:labels.confirmPass'), value: confirm ?? "", dense: true, secureTextEntry: true, mode: "outlined", onChangeText: (v) => {
                        verifyStrength(v, password, true);
                        setConfirm(v);
                    } }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: working, type: "outline", text: t('login:buttons.cancel'), onPress: () => props.navigation.navigate("Login") }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2, marginLeft: 12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: working || !isValid, text: t('login:buttons.save'), onPress: handleReset }) })] }) }), message && ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.messageOuter, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.message, children: message }) }))] }));
};
const RevertSecondFactor = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [info, setInfo] = react_1.default.useState(null);
    const [working, setWorking] = react_1.default.useState(false);
    const [message, setMessage] = react_1.default.useState(null);
    const handleError = (code) => {
        switch (code) {
            case "auth/expired-action-code":
                setMessage(t('login:messages.expiredLink'));
                break;
            case "auth/invalid-action-code":
                setMessage(t('login:messages.invalidLink'));
                break;
            default:
                setMessage(t('common:messages.tryAgain'));
                break;
        }
    };
    react_1.default.useEffect(() => {
        setWorking(true);
        Authentication_1.default.GetActionCodeInfo(props.code)
            .then((action) => {
            setInfo(action?.data);
        })
            .catch((error) => handleError(error?.code))
            .finally(() => setWorking(false));
    }, []);
    const handleRemove = () => {
        setWorking(true);
        Authentication_1.default.ApplyActionCode(props.code)
            .then(() => props.navigation.navigate("Login"))
            .catch((error) => handleError(error?.code))
            .finally(() => setWorking(false));
    };
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
            paddingHorizontal: (size != 'sm' ? '4%' : '2%'),
            paddingVertical: '2%'
        }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.section, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, textAlign: 'center' }, children: t('login:text.mfaRevert') }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: [styles.section, { marginTop: 12, marginBottom: 12 }], children: [(info && !working) &&
                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center', paddingVertical: 8 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Primary, icon: Theme_1.ICONS.Solid.MobileScreenButton, size: 22, style: { marginRight: 12, marginBottom: -1 } }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: 18, fontWeight: '400' }, children: info?.multiFactorInfo?.factorId == 'totp' ? info?.multiFactorInfo?.displayName : info?.multiFactorInfo?.phoneNumber }) }), (0, jsx_runtime_1.jsx)(Button_1.default, { color: THEME.Red, type: "outline", "aria-label": t('profile:buttons.mfaRemove'), text: t('profile:buttons.mfaRemove'), onPress: handleRemove, style: { paddingHorizontal: 12 } })] }), working &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: THEME.Primary, size: "large" }) }), message &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.message, children: message }) })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'row', marginVertical: 8, marginHorizontal: 2 }, children: (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", text: t('login:buttons.goBack'), onPress: () => props.navigation.navigate("Login") }) }) })] }));
};
function Login(props) {
    const styles = useStyles();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const sessionContext = react_1.default.useContext(SessionContext_1.SessionContext);
    const modes = [
        'login',
        'resetPassword',
        'revertSecondFactorAddition',
        'forgotUsername',
        'resetUsername',
        'redirect'
    ];
    // Google Identity Platform will send [mode] and [oobCode].
    // [mode] can be "resetPassword" or a few others.
    // [oobCode] is alphanumeric "out of band" code for reset.
    let mode = props.route?.params?.mode ?? "login";
    let code = props.route?.params?.oobCode;
    let nonce = props.route?.params?.nonce;
    if (props.route?.params?.SAMLRequest &&
        sessionContext.status == SessionContext_1.SessionStatus.Authenticated) {
        mode = 'redirect';
    }
    if (!modes.includes(mode)) {
        // Mode is not recognized, default to login.
        mode = 'login';
    }
    let background = null;
    if (size != 'sm') {
        background = Theme_1.IMAGES.LoginBackgroundWeb;
    }
    else {
        background = Theme_1.IMAGES.LoginBackground;
    }
    const handleForgot = async () => {
        props.navigation.navigate("Login", { mode: "resetPassword" });
    };
    const handleForgotUsername = async () => {
        props.navigation.navigate("Login", { mode: "forgotUsername" });
    };
    const renderForm = () => {
        return ((0, jsx_runtime_1.jsx)(FadeInView_1.default, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.ScrollView, { keyboardDismissMode: "none", keyboardShouldPersistTaps: "handled", overScrollMode: "never", contentContainerStyle: { flexGrow: 1, alignItems: 'center', justifyContent: 'center', paddingHorizontal: '2%', paddingVertical: react_native_1.Platform.OS === 'ios' ? 0 : '2%' }, style: { flex: 1 }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.card, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: {
                                    paddingTop: '6%',
                                    paddingHorizontal: '2%',
                                    paddingBottom: '2%',
                                    alignItems: 'center'
                                }, children: (0, jsx_runtime_1.jsx)(Theme_1.NextepLogo, { height: size != 'sm' ? 80 : 60, width: "100%" }) }), (mode == 'login') &&
                                (0, jsx_runtime_1.jsx)(LoginForm, { navigation: props.navigation, onSuccess: props.onSuccess, onForgotPassword: handleForgot, onForgotUsername: handleForgotUsername }), (mode == 'redirect') &&
                                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 36, marginBottom: 48 }, children: (0, jsx_runtime_1.jsx)(react_native_1.ActivityIndicator, { color: THEME.Primary, size: 64 }) }), (mode == 'resetPassword') &&
                                ((code)
                                    &&
                                        (0, jsx_runtime_1.jsx)(ResetForm, { code: code, navigation: props.navigation })
                                    ||
                                        (0, jsx_runtime_1.jsx)(ForgotForm, { navigation: props.navigation })), (mode == 'revertSecondFactorAddition') &&
                                (0, jsx_runtime_1.jsx)(RevertSecondFactor, { code: code, navigation: props.navigation }), (mode == 'forgotUsername') &&
                                (0, jsx_runtime_1.jsx)(ForgotUsernameForm, { navigation: props.navigation }), (mode == "resetUsername") &&
                                (0, jsx_runtime_1.jsx)(ResetUsernameForm, { navigation: props.navigation, nonce: nonce })] }), (!Helper_1.Helper.isPlatformWeb && mode == 'login') &&
                        (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { alignSelf: 'flex-end', marginHorizontal: 12, marginTop: 4 }, children: (0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: { opacity: 0.75, color: THEME.AlwaysWhite, fontSize: 12 }, children: ["v", react_native_device_info_1.default.getVersion()] }) })] }) }));
    };
    return ((0, jsx_runtime_1.jsx)(react_native_1.ImageBackground, { resizeMode: "cover", source: background, style: styles.container, children: (0, jsx_runtime_1.jsx)(react_native_1.KeyboardAvoidingView, { behavior: react_native_1.Platform.OS === 'ios' ? 'padding' : 'height', style: { flex: 1 }, keyboardVerticalOffset: 0, children: (0, jsx_runtime_1.jsx)(react_native_safe_area_context_1.SafeAreaView, { style: { flex: 1 }, children: renderForm() }) }) }));
}
